import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store/store";
import {
  deleteSelfPacedUser,
  loadSelfPacedUser,
} from "../../../../../store/features/AdminPanel/SelfPacedUser/SelfPacedUserApi";
import { editSelfPacedUserinInfo } from "../../../../../store/features/AdminPanel/SelfPacedUser/SelfPacedUserSlice";
import Table, {
  TableAction,
  TableBody,
  TableHeading,
} from "../../../../../shared/Table/Table";
import Avatar from "../../../../../shared/Avatar/Avatar";
import userImage from "../../../../../assets/icons/user.png";
import { roles } from "../../../../../helpers/utils/Constants/roles";
import Empty from "../../../../../shared/Empty/Empty";
import Loader from "../../UserAllTabs/Loader";
import DeleteModal from "../../../../../shared/DeleteModal/DeleteModal";

const roleLabels: Record<string, string> = {
  self_paced_product_manager: "Self Paced Product Manager",
  self_paced_scrum_master: "Self Paced Scrum Master",
  self_paced_agile_project_manager: "Self Paced Agile Project Manager",
  self_paced_product_owner: "Self Paced AI Product Owner",
  self_paced_business_analyst: "Self Paced Business Analyst",
  free_self_paced_business_analyst: "Self Paced Business Analyst",
  free_self_paced_product_owner: "Free Self Paced Product Owner",
};

interface Props {
  rolesToShow: "self_paced" | "free" | "certification";
}

const SelfPacedUserContent = ({ rolesToShow }: Props) => {
  // const {setShowModal,setShowEditModal} = props;
  const [showDeleteModal, setDeleteShowModal] = useState(false);
  const [userEmail, setUserEmail] = useState<any>("");
  const [userId, setUserId] = useState<any>("");

  const dispatch = useAppDispatch();

  const selfPacedUserState: any = useAppSelector((store: RootStore) => {
    return store.SelfPacedUserSlice;
  });
  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });

  // useEffect(() => {
  //   dispatch(
  //     loadSelfPacedUser({
  //       page: selfPacedUserState?.current_page,
  //       query: rolesToShow,
  //     })
  //   );
  // }, []);
  useEffect(() => {
    dispatch(
      loadSelfPacedUser({
        page: selfPacedUserState?.current_page,
        query: rolesToShow,
      })
    );
  }, [selfPacedUserState?.current_page]);

  useEffect(() => {
    if (
      !selfPacedUserState.deleteLoading &&
      selfPacedUserState.delete_success
    ) {
      setDeleteShowModal(false);
    }
  }, [selfPacedUserState]);

  const openDeleteUser = (userId: any, userEmail: any) => {
    setDeleteShowModal(true);
    setUserId(userId);
    setUserEmail(userEmail);
  };
  const deleteUser = () => {
    dispatch(deleteSelfPacedUser(userId)).then(() => {
      dispatch(
        loadSelfPacedUser({
          page: selfPacedUserState?.current_page,
          query: rolesToShow,
        })
      );
    });
  };

  const editUser = (user: any) => {
    dispatch(editSelfPacedUserinInfo(user));
  };

  // const filteredUsers = useMemo(() => {
  //   if (!rolesToShow.length) return selfPacedUserState?.users || [];
  //   return selfPacedUserState?.users?.filter((user: any) =>
  //     user?.all_roles?.some((role: string) => rolesToShow.includes(role))
  //   );
  // }, [rolesToShow, selfPacedUserState?.users]);

  // console.log("filteredUsers", filteredUsers);

  return (
    <div className="user__table__section">
      <Table
        heading={
          <TableHeading>
            <th>Name</th>
            <th>Email Id</th>
            <th>Self Paced User Id</th>
            <th>Created At</th>
            <th>Role</th>
            <th className="hide__text">.</th>
          </TableHeading>
        }
      >
        <TableBody>
          {!selfPacedUserState.loading &&
            selfPacedUserState?.users?.map((user: any) => {
              return (
                <tr key={user.id}>
                  <td className="flex_td">
                    <div className="avatar__section">
                      <Avatar imageUrl={user.avatar_url ?? userImage} />
                    </div>
                    {user.name}
                  </td>

                  <td>{user.email}</td>
                  <td>{user.id}</td>
                  <td>{moment(user.created_at).format("ll")}</td>
                  <td>
                    {(() => {
                      const roleNames: any = [];

                      // Ensure all_roles is always an array
                      const roles = Array.isArray(user?.all_roles)
                        ? user.all_roles
                        : [];

                      roles.forEach((role: any) => {
                        if (role && role !== "user") {
                          // Special mapping for free roles
                          if (role === "free_self_paced_business_analyst") {
                            roleNames.push("Free Self Paced Business Analyst");
                          } else if (role === "free_self_paced_product_owner") {
                            roleNames.push("Free Self Paced Product Owner");
                          } else {
                            // Use roleLabels mapping if available, otherwise use raw value
                            roleNames.push(roleLabels[role] || role);
                          }
                        }
                      });

                      return roleNames.join(", ");
                    })()}
                  </td>

                  <TableAction
                    onEdit={() => editUser(user)}
                    onDelete={() => openDeleteUser(user.id, user.email)}
                    hideDelete={authState.tac_user?.role !== roles.SYSTEM_ADMIN}
                  />
                </tr>
              );
            })}
        </TableBody>
      </Table>

      {!selfPacedUserState.loading &&
        selfPacedUserState?.users?.length === 0 && (
          <div className="mt-5 handle__empty__container__div">
            <Empty emptyText="It seems empty." custombg={true} />
          </div>
        )}
      {selfPacedUserState.loading && !selfPacedUserState.req_success && (
        <Loader />
      )}
      <DeleteModal
        message={`The user with "${userEmail}" email address is about to be
        deleted. Please confirm this action as you won't be able to
        revert this action.`}
        showModal={showDeleteModal}
        setShowModal={setDeleteShowModal}
        loading={selfPacedUserState.deleteLoading}
        onClick={deleteUser}
      />
    </div>
  );
};

export default SelfPacedUserContent;
